import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../ui/FormGroup';
import Input from '../ui/Input';

const SPACE_CODE = '\u00A0';
const InputComponent = (options) => {
    const [validMessage, setValidMessage] = useState(SPACE_CODE);

    const onValidate = (value) => {
        if (value.length > 8) {
            setValidMessage('Максимальное количество знаков - 8 шт');
            return false;
        } else if (value && !/^(\S)+$/g.test(value)) {
            setValidMessage('Монограмма может содержать только буквы кириллицы и латинского алфавита');
            return false;
        } else {
            setValidMessage(SPACE_CODE);
            return true
        }
    }

    return (
        <FormGroup
            variation={'center'}
            label={options.label}
            className={'margin-auto input-field-label'}
        >
            <Input
                {...options.input}
                onChange={(event, value) => {
                    if(onValidate(value)) {
                        options.input.onChange(value)
                    }
                }}
                onBlur={() => {
                    options.input.onBlur()
                }}
                variation={'regular'}
                style={{margin: 'auto'}}
                inputStyle={options.isMobile ? {
                    textAlign: 'center',
                    fontSize: '2.5em',
                    background: 'transparent',
                    height: '54px',
                    lineHeight: '54px',
                    padding: '0 10px'}
                : {
                    textAlign: 'center', 
                    fontSize: '3em', 
                    padding: '20px 20px', 
                    height: '70px'
                }}
                placeholder={options.placeholder || ''}
                className={options.isMobile ? 'w-67' : 'w-60'}
            >
            </Input>
            <p className='input-field__validaion-message'>{validMessage}</p>
        </FormGroup>
    )
}

InputComponent.propTypes = {
    label: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
}

export default InputComponent;